<script>
  import { fade } from "svelte/transition";
  import Title from "../components/Title.svelte";
  import Alert from "../components/Alert.svelte";
  import Navigationbar from "../components/Navigationbar.svelte";
  import Placeholder from "../components/placeholder/Placeholder.svelte";
  import Select from "svelte-select";

  //liblary
  import axios from "axios";
  import { session } from "../components/js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  //scroll to top every page load
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  //navigation
  let navigation = [];
  $: if (settings.loggedin == true) {
    if (settings.data.pen != undefined) {
      navigation["message"] = settings.data.pen.nm;
    } else {
      navigation["message"] = "Selamat Datang";
    }
  } else {
    navigation["message"] = "Selamat Datang";
  }

  //alert
  let alert;
  $: alert = []; 
  let itemsDisplay = false;
  let items = [];

  function loadAlamat() {
    axios
      .get(settings.url + "/sipade/alamat", {
        params: {
          authorization: settings.token,
        },
      })
      .then(function (response) {
        items = response.data;
        itemsDisplay = true;
      })
      .catch(function (error) {
        if (error.response.status == 401) {
          localStorage.removeItem("t");
          redirect("/login");
        } else {
          if (error.response.data.message) {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda belum terhubung dengan baik",
                color: "orange",
              },
            ];
          }
        }
      });
  }
  loadAlamat();
  function loadingBtn(e) {
    let el = this;
    el.setAttribute("disabled", "disabled");
    let reset = e.srcElement.innerHTML;
    this.innerHTML = "Memproses...";
    setTimeout(() => {
      el.innerHTML = reset;
      el.removeAttribute("disabled");
    }, 10000);
  }

  let lat = "-6.6894830820344895";
  let long = "106.87940311589048";

  let utama = false;
  let catatan = "";
  let utamaval;
  $: if (utama == true) {
    utamaval = 1;
  } else {
    utamaval = 0;
  }
  let require;
  $: require = {
    labelalamat: "",
    namapenerima: "",
    telp: "",
    alamat: "",
    alamat_map: "",
    pass: "",
    area: undefined,
    lat: "",
    long: "",
  };

  let number = {};
  //#FORM Data Payload

  let errorForm;
  $: errorForm = errorForm;
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    for (var n in number) {
      document.getElementById(n + "-warning").style.display = "none";
      document.getElementById(n + "-labelwarning").style = "";
      document.getElementById(n + "-warning").innerHTML = "";
      if (/^\+?([0-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }
  function handleSubmit() {
    let payload = {
      label: require.labelalamat,
      address: require.alamat,
      address_map: require.alamat_map,
      area: require.area,
      pass: require.pass,
      catatan: catatan,
      nama_penerima: require.namapenerima,
      telp: require.telp,
      utama: utamaval,
      lat: require.lat,
      long: require.long,
    };

    let valid = validator();
    if (valid) {
      axios
        .post(
          settings.url + "/sipade/alamat?authorization=" + settings.token,
          payload
        )
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Dekatan",
              message: response.data.message,
              color: "green",
            },
          ];

          setTimeout(() => {
            loadAlamat();
            window.scroll({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }, 3000);
        })
        .catch(function (error) {
          if (error.response.status == 401) {
            localStorage.removeItem("t");
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: "Anda mungkin harus login kembali",
                color: "orange",
              },
            ];
          } else {
            alert = [
              ...alert,
              {
                title: "Dekatan",
                message: error.response.data.message,
                color: "orange",
              },
            ];
          }
        });
    } else {
      alert = [
        ...alert,
        {
          title: "Dekatan",
          message: "Isilah kolom dengan benar",
          color: "orange",
        },
      ];
    }
  }

  $: lengthCount = require.labelalamat.length;
  $: lengthCountnama = require.namapenerima.length;
  $: lengthAlamatCount = require.alamat.length;
  $: lengthCatatanCount = catatan.length;

  import Item from "../components/select/Item.svelte";
  import loadOptions from "../components/select/area.js";

  const optionIdentifier = "id";
  const getOptionLabel = (option) => option.desa;
  const getSelectionLabel = (option) =>
    option.desa + " " + option.kec + " " + option.kab + " - " + option.prov;

  import "leaflet/dist/leaflet.css";

  let L = window.L;
  let div = "map";
  function validateLatLng(latitude, longtitude) {
    if (latitude == "" || longtitude == "") {
      alert = [
              ...alert,
        {
          title: "Dekatan",
          message: "Kordinat Masih Kosong",
          color: "orange",
        },
      ];
      return false;
    } else {
      if (isFinite(latitude) && Math.abs(latitude) <= 90) {
        if (isFinite(longtitude) && Math.abs(longtitude) <= 180) {
          return true;
        } else {
          alert = [
              ...alert,
            {
              title: "Dekatan",
              message: "Kordinat Longtitude Tidak Valid",
              color: "orange",
            },
          ];
          return false;
        }
      } else {
        alert = [
              ...alert,
          {
            title: "Dekatan",
            message: "Kordinat Latitude Tidak Valid",
            color: "orange",
          },
        ];
        return false;
      }
    }
  }
  function addMapPicker() {
    if(validateLatLng(require.lat, require.long)){
    document.getElementById("contmap").innerHTML = "";
    document.getElementById("contmap").style.display = "block";
    document.getElementById("contmap").innerHTML =
      "<div id='map' style='width: 100%; height: 100%;'></div>";
    let mapCenter = [require.lat, require.long];
    var map = L.map(div, { center: mapCenter, zoom: 15 });
    
    var aIcon = new L.Icon({
        iconUrl:
          "https://api.geoapify.com/v1/icon/?type=material&color=%23fd7319&size=large&icon=store&textSize=small&apiKey=1b48259b810e48ddb151889f9ea58db0",
        shadowUrl:
          "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });
    L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
      maxZoom: 18,
      attribution:
        '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
      id: "PositionPicker",
      noWrap: true,
    }).addTo(map);
    var marker = L.marker(mapCenter, {
      draggable: true,icon: aIcon
    }).addTo(map);
    marker.bindPopup("Geser Hingga Sesuai").openPopup();
    function updateMarker(lat, lng) {
      axios
        .get(
          "https://shipper.id/bos/geodata/json_map_area?latlng=" +
            lat +
            "," +
            lng
        )
        .then(function (response) {
          marker.bindPopup(response.data.geocode.formatted_address).openPopup();
          require.alamat_map = response.data.geocode.formatted_address;
        })
        .catch(function (error) {
          marker.bindPopup("Geser Hingga Sesuai").openPopup();
        });
      return false;
    }

    marker.on("drag", function (e) {});
    marker.on("dragstart", function (e) {});
    marker.on("dragend", function (e) {
      require.lat = e.target._latlng.lat;
      require.long = e.target._latlng.lng;
      map.panTo([e.target._latlng.lat, e.target._latlng.lng]);
      updateMarker(e.target._latlng.lat, e.target._latlng.lng);
    });
    } else {
      
    }
  }

  function getLocation() {
    navigator.geolocation.getCurrentPosition(
      displayLocationInfo,
      handleLocationError,
      { maximumAge: 1500000, timeout: 0, enableHighAccuracy: true }
    );
  }
  function displayLocationInfo(position) {
    require.lat = position.coords.latitude;
    require.long = position.coords.longitude;
    console.log(
      "display:" + position.coords.latitude + "," + position.coords.longitude
    );
    addMapPicker();
  }

  function handleLocationError(error) {
    switch (error.code) {
      case 3:
        // timeout was hit, meaning nothing's in the cache
        // let's provide a default location:
        displayLocationInfo({ coords: { longitude: long, latitude: lat } });

        // now let's make a non-cached request to get the actual position
        navigator.geolocation.getCurrentPosition(
          displayLocationInfo,
          handleLocationError
        );
        break;
      case 2:
        // ...
        break;
      case 1:
      // ...
    }
  }

  function displayLocationbySelect(lat, long) {
    require.lat = lat;
    require.long = long;
    addMapPicker();
  }
  function handleSelect(selectedVal) {
    console.log(selectedVal);
    displayLocationbySelect(selectedVal.detail.lat, selectedVal.detail.lang);
  }
</script>
<svelte:head>
<title>Kellola Alamat Pengiriman - Dekatan</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}
<Navigationbar
  backbtn="true"
  message={navigation['message']}
  title="Profil Anda" />
<main
  transition:fade
  class="container px-1 pt-24 mx-auto mb-32 lg:pt-24 md:pt-20 lg:px-0">
  <div class="pt-2 mx-auto my-5 lg:mt-10 lg:my-0">
    {#if itemsDisplay}
      <div class="max-w-lg mx-auto rounded-lg">
        <div class="w-full mx-auto my-5 lg:my-0">
          <div class="w-full mx-auto mb-2">
            <div class="p-10 bg-white rounded-md shadow-md">
              <form class="w-full" on:submit|preventDefault={handleSubmit}>
                <div id="stepcontID1" class="block stepcontID">
                  {#if errorForm}
                    {#if errorForm.length > 0}
                      <div
                        class="w-full p-2 mt-4 mb-5 text-sm italic text-red-500 border border-l-4 border-red-500 rounded-lg">
                        Mohon isi dengan benar,
                        <br />
                        {#each errorForm as e}
                          - Kolom
                          <b>{#if document.getElementById(e.field + '-labelwarning')}
                              {document.getElementById(e.field + '-labelwarning').innerText}
                            {/if}</b>
                          {e.message}<br />
                        {/each}
                      </div>
                    {/if}
                  {/if}
                  {#if items.data}
                    <Title
                      subtitle="Daftar Alamat Anda"
                      title="Alamat"
                      tipe="2" />
                    {#each items.data as a}
                      <div class="py-5 border-b-2">
                        <div>
                          <div class="text-sm">
                            <b
                              class="receiver-name">{a.nama_penerima}</b>&nbsp;<span
                              class="font-light">({a.label})</span>&nbsp;{#if a.utama == '1'}
                              <span
                                class="px-1 text-blue-600 bg-blue-200 rounded">Utama</span>
                            {/if}
                          </div>
                          <div class="text-sm">{a.telp}</div>
                          <div class="text-sm font-thin">
                            <div class="address">{a.address}</div>
                            <div class="text-xs uppercase">
                              {a.area.desa.jenis}
                              {a.area.desa.nama}
                              {a.area.kec.jenis}
                              {a.area.kec.nama}
                              <br />{a.area.kab.nama}
                              -
                              {a.area.prov.nama}
                            </div>

                            <div class="text-xs text-gray-500">
                              Catatan :
                              {a.catatan}
                            </div>
                          </div>
                        </div>
                      </div>
                    {/each}
                    {:else}
                    <div class="w-full lg:w-auto">
                      <div
                        class="w-full p-2 mx-auto mb-2 text-xs bg-blue-300 border-4 border-t border-b border-r border-blue-600 border-solid rounded shadow-lg lg:w-auto color-white">
                        <h2 class="text-sm font-bold">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            class="inline-block w-5 h-5">
                            <path
                              d="M4 8a6 6 0 0 1 4.03-5.67 2 2 0 1 1 3.95 0A6 6 0 0
                      1 16 8v6l3 2v1H1v-1l3-2V8zm8 10a2 2 0 1 1-4 0h4z" />
                          </svg>
                          Tambahkan Alamat anda
                        </h2>
                        <p>
                          Alamat ini digunakan sebagai pilihan tujuan pengiriman
                          saat anda berbelanja
                        </p>
                      </div>
                    </div>
                  {/if}

                  <Title
                    subtitle="Tambah Alamat Anda"
                    title="Tambah Alamat"
                    tipe="2" />
 
                  <section class="mt-10">
                    <label
                      for="labelalamat"
                      class="relative block text-sm font-light">
                      <input
                        maxlength="20"
                        id="labelalamat"
                        type="text"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="contoh : Rumah"
                        bind:value={require.labelalamat} />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="labelalamat-labelwarning">Label Alamat
                        <span
                          class="my-2 text-xs text-right text-gray-500">{lengthCount}/20</span></span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="labelalamat-warning" />
                    </label>
                  </section>

                  <section class="mt-5">
                    <label
                      for="namapenerima"
                      class="relative block text-sm font-light">
                      <input
                        maxlength="50"
                        id="namapenerima"
                        type="text"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="Nama Penerima"
                        bind:value={require.namapenerima} />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="namapenerima-labelwarning">Nama Penerima
                        <span
                          class="my-2 text-xs text-right text-gray-500">{lengthCountnama}/50</span></span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="namapenerima-warning" />
                    </label>
                  </section>

                  <section class="mt-5">
                    <label for="telp" class="relative block text-sm font-light">
                      <input
                        autocomplete="off"
                        minlength="10"
                        id="telp"
                        type="text"
                        name="telp"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="628*********"
                        bind:value={require.telp} />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white rounded"
                        id="telp-labelwarning">No. HP/WA <span class="text-xs">(tanpa awalan + atau 0)</span></span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="telp-warning" />
                    </label>
                  </section>

                  <section class="mt-5">
                    <label for="area" class="relative block text-sm font-light">
                      <div
                        class="text-sm text-gray-800 placeholder-gray-400 themed">
                        <Select
                          on:select={handleSelect}
                          {loadOptions}
                          {optionIdentifier}
                          {getSelectionLabel}
                          {getOptionLabel}
                          {Item}
                          bind:selectedValue={require.area}
                          noOptionsMessage="Ketikan Nama Desa"
                          placeholder="Ketik Nama Desa 🍺" />
                        <span
                          class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                          id="area-labelwarning">Pilih Desa</span>
                        <span
                          class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                          id="area-warning" />
                      </div>
                    </label>
                  </section>
                  <section class="mt-5 paragraphs">
                    <label
                      for="alamat"
                      class="relative block text-sm font-light">
                      <textarea
                        placeholder="Jalan Beringin No. 24 RT.02 RW. 03 KP. Nangka"
                        maxlength="200"
                        id="alamat"
                        class="w-full h-24 p-4 text-sm placeholder-gray-400 border border-gray-500 rounded form-textarea hover:border-blue-400 focus:shadow-none"
                        bind:value={require.alamat} />
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="alamat-warning" />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="alamat-labelwarning">Alamat Lengkap
                        <span
                          class="my-2 text-xs text-right text-gray-500">{lengthAlamatCount}/200</span></span>
                    </label>
                  </section>

                  <section class="mt-5 paragraphs">
                    <label
                      for="alamatmap"
                      class="relative block text-sm font-light">
                      <textarea
                        readonly
                        placeholder="Jalan Beringin No. 24 RT.02 RW. 03 KP. Nangka Desa Durian Kecamatan Salaka Kabupaten Pisangan Provinsi Lengkeng"
                        maxlength="200"
                        id="alamatmap"
                        class="w-full h-24 p-4 text-sm placeholder-gray-400 border border-gray-500 rounded form-textarea hover:border-blue-400 focus:shadow-none"
                        bind:value={require.alamat_map} />
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="alamatmap-warning" />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="alamatmap-labelwarning">Alamat di Map
                      </span>
                    </label>
                  </section>

                  <section class="mt-5">
                    <label for="lat" class="relative block text-sm font-light">
                      <input
                        id="lat"
                        type="text"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="latitude"
                        bind:value={require.lat} />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="lat-labelwarning">latitude</span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="lat-warning" />
                    </label>
                  </section>

                  <section class="mt-5">
                    <label for="long" class="relative block text-sm font-light">
                      <input
                        id="long"
                        type="text"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="Longtitude"
                        bind:value={require.long} />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="long-labelwarning">Longtitude</span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="long-warning" />
                    </label>
                  </section>

                  <section>
                    <span
                      class="px-2 text-xs border rounded cursor-pointer focus:bg-gray-500 focus:outline-none"
                      on:click={addMapPicker}>
                      Buka Peta
                    </span>
                    <span
                      class="px-2 text-xs border rounded cursor-pointer focus:bg-gray-500 focus:outline-none"
                      on:click={getLocation}>
                      Ambil Posisi Saat Ini
                    </span>
                  </section>

                  <div
                    id="contmap"
                    class="sticky w-full my-1 overflow-hidden rounded"
                    style="display:none; height:250px;">
                    <div id="map" style="width: 100%; height: 100%;" />
                  </div>

                  <section class="mt-5 paragraphs">
                    <label
                      for="catatan"
                      class="relative block text-sm font-light">
                      <textarea
                        placeholder="contoh : Pagar Biru Samping Ruko Sembako"
                        maxlength="200"
                        id="catatan"
                        class="w-full h-24 p-4 text-sm placeholder-gray-400 border border-gray-500 rounded form-textarea hover:border-blue-400 focus:shadow-none"
                        bind:value={catatan} />
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="catatan-warning" />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                        id="catatan-labelwarning">Catatan
                        <span
                          class="my-2 text-xs text-right text-gray-500">{lengthCatatanCount}/200</span></span>
                    </label>
                  </section>
                  <section class="items-center mt-5 paragraphs">
                    <label
                      for="utama"
                      class="relative block text-sm font-light"><input
                        type="checkbox"
                        name="utama"
                        id="utama"
                        class="text-3xl form-checkbox"
                        bind:checked={utama} />
                      <span
                        class="inline-block px-1 mx-2 text-sm font-light bg-white"
                        id="utama-labelwarning">Jadikan
                        <span
                          class="px-1 text-blue-600 bg-blue-200 rounded">Alamat
                          Utama</span></span></label>
                  </section>

                  <p class="mt-5 text-sm text-center">
                    Konfirmasi kata sandi untuk memastikan ini adalah anda
                  </p>

                  <section class="mt-5">
                    <label for="pass" class="relative block text-sm font-light">
                      <input
                        autocomplete="off"
                        type="password"
                        id="pass"
                        name="pass"
                        class="w-full text-sm placeholder-gray-400 border-gray-500 form-input hover:border-blue-400 focus:shadow-none"
                        placeholder="Kata sandi..."
                        bind:value={require.pass} />
                      <span
                        class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white rounded"
                        id="pass-labelwarning">Password</span>
                      <span
                        class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                        id="pass-warning" />
                    </label>
                  </section>

                  <button
                    type="button"
                    class="w-auto px-10 py-2 my-5 text-gray-100 bg-green-600 rounded text-1xl focus:bg-gray-500 focus:outline-none"
                    on:click={loadingBtn}
                    on:click={handleSubmit}>
                    SIMPAN
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    {:else}
      <div class="max-w-lg mx-auto rounded-lg">
        <div class="w-full mx-auto my-5 lg:my-0">
          <div class="w-full mx-auto mb-2">
            <div class="p-10 bg-white rounded-md shadow-md">
              {#each [1] as l}
                <Placeholder type="6" />
              {/each}
            </div>
          </div>
        </div>
      </div>
    {/if}
  </div>
</main>
